<template>
  <div class="consult">
    <Header @search="onSearch" />
    <Tab />
    <div class="consult_container" v-loading="loading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">{{
          $t('首页')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }">{{
          $t('新闻中心')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }" v-if="type == 1">{{
          $t('新闻动态')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }" v-if="type == 2">{{
          $t('最新通知')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }" v-if="type == 3">{{
          $t('媒体服务')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/search' }" v-if="type == 4">{{
          $t('搜索结果页')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }" v-if="type == 5">{{
          $t('预约申请')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }" v-if="type == 6">{{
          $t('资料中心')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type === 8">{{
          $t('焦点新闻')
        }}</el-breadcrumb-item>

        <el-breadcrumb-item v-if="type == 1">{{
          $t('新闻详情')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == 2">{{
          $t('通知详情')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == 3">{{
          $t('媒体详情')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == 4">{{
          $t('搜索详情')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == 5">{{
          $t('预约详情')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == 6">{{
          $t('资料详情')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == 7">{{
          $t('服务信息')
        }}</el-breadcrumb-item>
      </el-breadcrumb>
      <ul class="title_box">
        <li class="headline" v-html="consultList.title"></li>
        <li class="subhead">
          <span>{{ $t('来源') }}: </span>
          <span>{{
            consultList.source
              ? consultList.source
              : consultList.from | filterParams
          }}</span
          >&emsp;
          <span>{{ $t('发表时间') }}：</span>
          <span>{{ consultList.pubTime | timeStampToString }}</span
          >&emsp;
          <!-- <span>{{ $t('浏览量') }}：</span>
          <span>{{ pv | filterParams }}</span> -->
        </li>
      </ul>
      <ul class="c_container">
        <div class="ql-snow">
          <div
            class="ql-editor"
            :class="{ video: consultList.contentType == 2 }"
            v-html="richText"
            @click="addComment($event)"
          ></div>
        </div>
        <!-- <p
            :class="{ video: consultList.contentType == 2 }"
            v-html="richText"
            @click="addComment($event)"
          ></p> -->
        <a
          style="line-height:30px;width:1200px;text-align: center;"
          :href="url"
          v-if="consultList.contentType == 5"
        >
          {{ consultList.fileName }}
          <b class="downLoad">{{ $t('下载') }}</b>
        </a>
        <!-- <img :src="consultList.appHeader" alt="" />
        <li v-show="consultList.appHeader">
          {{ $t('图片来源') }}：{{ consultList.source }}
        </li> -->
        <!-- <img src="../assets/img/video.png" alt="" />
      <p>
        在教育国际合作方面，2019年服贸会期间举办的“世界500强企业CBD高峰论坛”上，北京市朝阳区委书记王灏表示，朝阳区将进一步完善国际化功能布局，加强国际交往功能配套建设，推动国际学校、国际医院、国际人才社区等项目的落地。其中包括，将进一步健全国际教育的服务体系，研究开通外籍高端人才子女入学的绿色通道，为外籍高端人才提供国际化、专业化的教育保障服务。
      </p> -->
      </ul>
    </div>
    <div class="demo-image__preview">
      <el-image
        ref="img"
        style="width: 0px; height: 0px"
        :src="preview"
        :preview-src-list="srcList"
      >
      </el-image>
    </div>
    <Footer />
  </div>
</template>
<script>
import '@/assets/css/consult.css'
import { getNoticeContentDetail, getPv } from '@/api/news'
import { formatDate } from '@/utils/formatDate'
import Header from './components/headerBanner'
import Tab from './components/headerTab'
import Footer from './components/footer'
import getTranslation from '@/locale/getTranslation'
export default {
  data() {
    return {
      id: '',
      consultList: [],
      url: '',
      richText: '',
      type: '',
      preview: '',
      srcList: [],
      pv: '',
      loading: false
    }
  },
  components: {
    Header,
    Tab,
    Footer
  },
  created() {
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    if (this.type == 2) {
      document.title = getTranslation('新闻中心通知详情')
    } else if (this.type == 5) {
      document.title = getTranslation('新闻中心预约详情')
    } else if (this.type == 4) {
      document.title = getTranslation('新闻中心搜索详情')
    } else if (this.type == 3) {
      document.title = getTranslation('新闻中心媒体详情')
    } else if (this.type == 6) {
      document.title = getTranslation('新闻中心资料详情')
    }
  },
  async mounted() {
    this.loading = true
    // this.getPvNum(this.id)
    try {
      const { result } = await getNoticeContentDetail(this.id)
      this.consultList = result.data
      let { richText, url, contentType } = this.consultList
      if (contentType == 2) {
        if (richText !== '') {
          this.richText = richText
        }
      } else if (contentType == 1) {
        this.url = url
        window.location.href = this.url
        // window.open(this.url)
        // this.$router.go(-1)
      } else {
        this.url = url
      }
    } catch (err) {
      console.log(err)
    } finally {
      this.loading = false
    }
    document.getElementById(
      'meta-keywords'
    ).content = `中国国际服务贸易交易会,服贸会,峰会,专题论坛,国际展会,服务贸易,京交会,交易会,新闻中心,${
      document.title
    },${
      this.consultList
        ? this.consultList.title + ',' + this.consultList.source
        : ''
    }`
  },
  //时间戳转换
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  },
  methods: {
    onSearch(input) {
      this.$router.push({
        name: 'pc_search',
        query: {
          search: input
        }
      })
    },
    async getPvNum(id) {
      let { result } = await getPv(id)
      this.pv = result.pv
    },
    addComment: function(event) {
      console.log(event)
      switch (event.target.nodeName) {
        case 'A': {
          event.preventDefault()
          this.downloadFile(event.target.href)
          break
        }
        case 'IMG': {
          if (event.target.parentNode.tagName !== 'A') {
            event.preventDefault()
            this.srcList = [event.target.currentSrc]
            this.preview = event.target.currentSrc
            console.log(this.$refs.img)
            this.$refs.img.clickHandler()
          }
          break
        }
      }
    },
    downloadFile(url) {
      const fileType = url.substring(url.lastIndexOf('.') + 1)
      try {
        let options = {
          source: '新闻中心-活动资讯',
          fileType,
          url
        }
        window.bridge.onFileDownload(JSON.stringify(options))
      } catch (error) {
        console.log('调用APP下载方法失败')
        window.open(url)
      }
    }
  }
}
</script>
